import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';

const StyledContent = styled.div`
    position: relative;
    max-height: ${ (props) => {
        const {
            contentStyle,
            open,
            refHeight,
        } = props;

        if (contentStyle.maxHeight && open) {
            return isNaN(contentStyle.maxHeight) ? contentStyle.maxHeight : `${ contentStyle.maxHeight }px`;
        }

        return open ? `${ refHeight }px` : '0';
    } };
    background-color: ${ theme.accordion.content };
    overflow: hidden;
    border: 1px solid ${ theme.accordion.border };
    border-top: none;
    border-bottom: none;
    transition: all .5s ease-in-out;
`;

const StyledInner = styled.div`
    padding: 20px;
`;

class AccordionContent extends React.Component {
    constructor() {
        super();

        this.state = {
            height: 0,
        };
    }

    componentDidMount() {
        if (!this.ref) {
            return;
        }

        this.setState({
            height: this.ref.clientHeight || 0,
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {
            open,
        } = this.props;

        const {
            height,
        } = this.state;

        if (nextProps.open !== open || nextState.height !== height) {
            return true;
        }

        return false;
    }

    handleRef = (node) => {
        this.ref = node;
    }

    render() {
        const {
            children,
            open,
            style,
        } = this.props;

        const {
            height,
        } = this.state;

        return (
            <StyledContent
                contentStyle={ style }
                open={ open }
                refHeight={ height }
            >
                <StyledInner
                    innerRef={ this.handleRef }
                >
                    { children }
                </StyledInner>
            </StyledContent>
        );
    }
}

AccordionContent.defaultProps = {
    style: {},
};

AccordionContent.propTypes = {
    children: PropTypes.node.isRequired,
    open: PropTypes.bool.isRequired,
    style: PropTypes.object,
};

export default AccordionContent;



// WEBPACK FOOTER //
// ./src/components/ui/accordion/AccordionContent.js